/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'resource/defense': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 0C4.478 0 0 4.477 0 10s4.478 10 10 10 10-4.477 10-10S15.522 0 10 0zm4.957 13.092c-.634 1.435-4.266 3.764-4.678 4.041l-.278.203-.278-.152c-.395-.263-3.881-2.563-4.668-4.103L5 5h10l-.043 8.092z"/><path pid="1" d="M10 16l-.265-.165c-.334-.208-3.273-2.077-3.713-3.484L6 12.202V6h8l-.018 6.481c-.365 1.35-3.161 3.08-3.718 3.427L10 16zm-3-3.884c.299.745 1.885 1.971 3 2.7 1.194-.78 2.752-2.011 3-2.691V7H7v5.116z"/>'
  }
})
